import { Document, Wallet, Chart, TickSquare, People, Setting } from "react-iconly";
import { MdOutlineFlightTakeoff } from "react-icons/md";

const pages = [
    {
        id: "expense-claim-menu",
        title: "Expense Claim",
        icon: <Document set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "expense-claim",
                title: "Expense Claim",
                navLink: "/expenseclaim",
            },
        ],
    },
    {
        id: "expense-advance-menu",
        title: "Employee Advance",
        icon: <People set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "employee-advance",
                title: "Operational Advance",
                navLink: "/employeeadvance",
            },
            {
                id: "travel-advance",
                title: "Travel Advance",
                navLink: "/traveladvance",
            },
        ],
    },
    {
        id: "approvals",
        title: "Approvals",
        icon: <TickSquare set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "approvals-sub",
                title: "Approvals",
                navLink: "/approvals",
            }
        ],
    },
    {
        id: "settlement",
        title: "Settlement",
        icon: <Wallet set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "settlementposting",
                title: "Settlement Posting",
                navLink: "/settlement",
            },
            {
                id: "settlementlist",
                title: "Settlement List",
                navLink: "/settlementlist",
            }
        ],
    },
    {
        id: "advancerefund",
        title: "Advance Refund",
        icon: <Wallet set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "advancerefundposting",
                title: "Refund Posting",
                navLink: "/advancerefund",
            },
            {
                id: "advancerefundlist",
                title: "Refund List",
                navLink: "/refundlist",
            }
        ],
    },
    {
        id: "settings",
        title: "Settings",
        navLink: "/settings",
        icon: <Setting set="curved" size='small' />,
    },
    {
        id: "reports",
        title: "Reports",
        navLink: "/reportlist",
        icon: <Chart set="curved" size='small' />,
    },
    {
        id: "trip",
        title: "Trip",
        navLink: "/trips",
        icon: <MdOutlineFlightTakeoff set="curved" style={{ fontSize: '16px' }} />,
    },
];

export default pages;